import { createAsyncThunk } from "@reduxjs/toolkit";
import { api, RouteAPI } from "../service/apiService";
import { UserStructureResponse } from "../../structures/model/StructureModel";
import { AxiosError } from "axios";
import { ResponseMessage } from "../model/ResponseMessage";

export interface NotificationProps {
    id: string;
    title: string;
    body: string;
    createdAt: string;
    read: boolean;
    targetRole: string;
    data: {
        url: string;
    };
}

export const fetchNotifications = createAsyncThunk(
    "notifications/fetchNotifications",
    async (
        {
            page = 1,
            itemsPerPage = 10,
        }: { page?: number; itemsPerPage?: number },
        { rejectWithValue }
    ) => {
        try {
            const queryParams = new URLSearchParams({
                page: page.toString(),
                itemsPerPage: itemsPerPage.toString(),
            }).toString();

            const response = await api<NotificationProps[]>(
                `${RouteAPI.NOTIFICATIONS}?${queryParams}`,
                "GET"
            );

            return response.data;
        } catch (error: any) {
            const errorMessage =
                error.response?.data?.message ||
                error.response?.data ||
                "An error occurred while fetching notifications.";

            return rejectWithValue(errorMessage);
        }
    }
);

export const readNotifications = createAsyncThunk(
    "notifications/markAsRead",
    async (id: string, { rejectWithValue }) => {
        try {
            await api(
                `${RouteAPI.NOTIFICATIONS}/${id}`,
                "PATCH",
                {
                    read: true,
                },
                {
                    headers: {
                        "Content-Type": "application/merge-patch+json",
                    },
                }
            );
            return id;
        } catch (error: any) {
            const errorMessage =
                error.response?.data?.message ||
                error.response?.data ||
                "An error occurred while updating the notification.";
            return rejectWithValue(errorMessage);
        }
    }
);

export const getNotificationDisponibilityStructure = createAsyncThunk<
    UserStructureResponse,
    string
>("notification/getStructureDisponibility", async (id, { rejectWithValue }) => {
    try {
        const response = await api(
            `${RouteAPI.DISPONIBILITE_STRUCTURE}/${id}?enabled=true`,
            "GET"
        );
        return response.data as UserStructureResponse;
    } catch (error) {
        return rejectWithValue(error as AxiosError<ResponseMessage>);
    }
});
